/*
 * CAUTION: The values below are relied upon by the P0 CLI. Any changes made here may need to be reflected in and should
 * be tested in the P0 CLI.
 */
import type { ArgsOf, RequestOf } from "../../../access/types.ts";
import { Access } from "../../../access/types.ts";

export const CustomIntegrationAccesses = {
  resource: Access({
    description: "Custom resource access",
    label: "Resource",
    maturity: "ga",
    delegation: {},
    generated: {},
    parameters: {
      application: {
        type: "static",
        label: "Application",
        description: "Select an application to provide access to",
        isPreselect: true,
      },
      item: {
        type: "dynamic",
        label: "Item",
        description: "Select an item to provide access to",
      },
    },
    render: { locator: "application" } as const,
  }),
};

export type CustomIntegrationAccesses = typeof CustomIntegrationAccesses;
export type CustomIntegrationAccess =
  CustomIntegrationAccesses[keyof CustomIntegrationAccesses];

export type CustomResourceAccess = CustomIntegrationAccesses["resource"];

export type CustomResourceRequest = RequestOf<CustomResourceAccess>;

export type CustomResourceArgs = ArgsOf<CustomIntegrationAccess>;
